// Components/Dashboard/AppCards.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./style/dashboard.css";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";
import { AuthContext } from "../context/AuthContext";

export default function AppCards({ data }) {
  const navigate = useNavigate();
  const { USE } = useContext(AuthContext);

  const getBasePath = () => {
    const profilId = USE?.profil_id;
    
    if (profilId === 2) {
      return '/SupportTechnique';
    }
    else if (profilId === 3) {
      return '/Gerant';
    }
    return '/Gerant';
  };

  const handleGPSClick = () => {
    const basePath = getBasePath();
     const profilId = USE?.profil_id;

     if (profilId === 3) {
      navigate(`${basePath}/appareils`);
    } else {
      navigate(`${basePath}/appareils/GPS`);
    }
  };

  const handleSIMClick = () => {
    const basePath = getBasePath();
     const profilId = USE?.profil_id;
    
    if (profilId === 3) {
      navigate(`${basePath}/appareils`);
    } else {
      navigate(`${basePath}/appareils/SIM`);
    }
  };

  return (
    <MDBRow className="cardRow">
      <MDBCol>
        <MDBCard 
          className="cardStats" 
          style={{ cursor: 'pointer' }}
          onClick={handleGPSClick}
        >
          <MDBCardBody>
            <MDBCardTitle>Nbr GPS installé </MDBCardTitle>
            <MDBCardText>
              {data && data.numberGPS != null ? data.numberGPS : "en cours"}
            </MDBCardText>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol>
        <MDBCard className="cardStats">
          <MDBCardBody>
            <MDBCardTitle>Modéle plus installée</MDBCardTitle>
            <MDBCardText>
              {data && data.mostmodel && data.mostmodel.mostGPSInstalled > 0
                ? data.mostmodel.nameModele
                : data.mostmodel == null
                ? "Aucun modèle disponible"
                : "en cours"}
            </MDBCardText>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol>
        <MDBCard 
          className="cardStats" 
          style={{ cursor: 'pointer' }}
          onClick={handleSIMClick}
        >
          <MDBCardBody>
            <MDBCardTitle>Nbr SIM installée</MDBCardTitle>
            <MDBCardText>
              {data && data.numberSIM >= 0 ? data.numberSIM : "en cours"}
            </MDBCardText>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol>
        <MDBCard className="cardStats">
          <MDBCardBody>
            <MDBCardTitle>Acc plus installée</MDBCardTitle>
            <MDBCardText>
              {data &&
              data.ACCESSORY &&
              data.ACCESSORY.mostAccessoryInstalled > 0
                ? data.ACCESSORY.nameModele
                : data.ACCESSORY == null
                ? "pas accessoire installé"
                : "en cours"}
            </MDBCardText>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>
  );
}